import type { FaireProductEntity } from "../../entity_types/product";

export const p_27ccil83nq: FaireProductEntity = {
  token: "p_27ccil83nq",
  type: "product",
  name: "Custom Hanging Wall Banner (Your Logo / Your Own Design)",
  brandToken: "b_191br80oqs",
  brandName: "The Cotton & Canvas Co.",
  imageUrl: "https://cdn.faire.com/fastly/3c513346a43e4917c832f0810c8ada9879fc09636568902bd9925bf75c5241fa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3f81184340c575a9aca49d30ff73ce0642c1c1c59a8a80928b1e27db6b6333f2.jpeg",
    "https://cdn.faire.com/fastly/4ef81297b2d48f22b007f4c8165ef5e44e032f1a1e3382b9371970f3a0e85d61.jpeg",
    "https://cdn.faire.com/fastly/a0760e03010ef67014ba3e6e725df20b3634be1f794fd8494c911fed41e16553.jpeg"
  ],
  priceDollars: 10,
  description: "Customize this item with your artwork, logo or design!\n\nSimply submit your artwork and we'll print it for you! We kindly request the artwork to be in high resolution format. A PDF, EPS, PSD, or AI file is required to ensure the print is sharp and not pixelated. JPGs above 1000 pixels can be accepted.\n\nThese canvas wall hanging banners add the perfect touch to your home decor! Printed on high quality cotton canvas material, these wall art banners make unique statement pieces for every room in your home. Its simple and unique design fits perfectly with all colors and themes! Mix, match and embellish with a variety of our designs! Banners are machine washable and easy to clean.\n\n• To purchase, kindly place your order and message us your artwork.\n• A proof available upon request.\n• Material: 100% Cotton Canvas Fabric (Natural Color)\n• Size: 14\" H x 10\" W\n• String is pre-tied and included (can be removed if needed)\n• Made in the USA\n• All personalized item sales are final.\n• Personalized items are non-ref",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:41.905Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
